import React from 'react'

const CoreComponent24 = ({contentcopy}) => {
  return (
    <div>
        <div className="row mt-80 d-flex justify-content-center">
            {contentcopy.map((val, i) => (
              <div key={i} className="col-lg-4 mb-4 ">
                <div
                  className="p-4 mb-4  bg-white h-100 rounded-4 border-bottom shadow-lg overflow-hidden"
                  style={{ height: ''}}
                >
                  <img className="mx-0 icon-logo" src={val.icon} alt="" />
                  <h3 className="fs-5 my-3 h3-heading  lh-base text-start"> {val.title}</h3>
                  <p className="fs-6 h3-para lh-base text-start">{val.desc}</p>
                </div>
              </div>
            ))}
          </div>
    </div>
  )
}

export default CoreComponent24